import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';

export const getCraneFiltersConfigByType = (): IFilterConfigItem[] => [
  {
    title: '# of Cranes',
    name: `property_crane_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.crane,
  },
  {
    title: 'Max Capacity',
    name: `property_crane_max_capacity`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.crane,
  },
  {
    title: 'Hook Height',
    name: `property_crane_hook_height`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.crane,
  },
  {
    title: 'Clearance',
    name: `property_crane_clearance`, // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.crane,
  },
];
